export default class BrowserInfoModel {
    BrowserName: string = '';

    BrowserFullVersion: string = '';

    BrowserMajorVersion: number = 0;

    NavigatorAppName: string = '';

    NavigatorUserAgent: string = '';
    
    OperatingSystem: string = '';
}